import type { ButtonProps } from "@mui/material";

/**
 * Dimensions for the two button sizes. `large` is the page's or dialog's primary choice and runs
 * bigger than the default, which is sized for inline and toolbar use.
 */
export const buttonSizing = (size: ButtonProps["size"]) =>
  size === "large"
    ? { height: "32px", padding: "0 16px", fontSize: "14px", lineHeight: "22px", fontWeight: 400 }
    : { height: "24px", padding: "0px 7px", fontSize: "12px", lineHeight: "20px" };
